import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
    selector: 'app-add-promotion',
    templateUrl: './add-promotion.component.html',
    styleUrls: ['./add-promotion.component.scss'],
    standalone: false
})
export class AddPromotionComponent implements OnInit {
  addPromotionForm!: FormGroup;
  userID: number;
  minDate: Date;

  constructor(public dialog: MatDialog,
    private dataService: DataService,
    public dialogRef: MatDialogRef<AddPromotionComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    this.userID = this.authService.getUserData().id;
    this.minDate = new Date();
    if (data && data.userID && data.userID > 0) {
      this.userID = data.userID;
    }

  }

  ngOnInit(): void {
    this.addPromotionForm = new FormGroup({
      percent: new FormControl(100),
      codesNumber: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(100)]),
      expireDate: new FormControl(null, [Validators.required]),
    });
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  closeDialog() {
    if (this.addPromotionForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    if (this.addPromotionForm.valid) {
      const date = new Date(this.addPromotionForm.get('expireDate')?.value);
      const timeOffsetInMS = date.getTimezoneOffset() * 60000;
      date.setTime(date.getTime() - timeOffsetInMS);
      const payload = {
        percentage: parseInt(this.addPromotionForm.get('percent')?.value.toString(), 10),
        count: parseInt(this.addPromotionForm.get('codesNumber')?.value.toString(), 10),
        expireDate: date,
        userId: parseInt(this.userID.toString(), 10),
        isSponsored : false
      };
      this.dataService.post('promotionCode/GeneratePromotionCode', payload).then((data: any) => {
        if (data.statusCode === 200) {
          this.dialogRef.close(data.data);
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Promotion added successfully',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    } else {
      this.addPromotionForm.markAllAsTouched();
    }
  }

}
